import http from 'shared/utils/http';

export const getLanguage = () => {
  return http.get('/netwila/language');
};
